import { useMemo } from 'react';
import useElementHeight from './useElementHeight';
import { stickyHeaderOffsetVar } from '../components/lifecare-studio/lifecareStudioClasses';

// Derives the per-render data the lifecare studio body needs: resolves the active
// section from the tab-to-section map and its current ui state, so the view layer
// can stay free of conditional lookups. The model picks the edit tool, so there is
// one comment bar per tab and no separate whole-plan / new-subsection surfaces.
const useLifecareStudioBody = ({ suggestedEditsState, tabState }) => {
  const {
    sectionByTabType,
    updateSectionComment,
    handleRegenerateSection,
    getSectionUiState,
    isSuggestedEditsLoading,
  } = suggestedEditsState || {};

  const { tabs, activeTabType, activeTab, handleTabClick } = tabState || {};

  const activeSection = useMemo(
    () => sectionByTabType?.get?.(activeTabType) || null,
    [sectionByTabType, activeTabType]
  );

  const activeSectionUiState = useMemo(() => {
    if (!activeSection) return 'idle';
    return getSectionUiState?.(activeSection.id) || 'idle';
  }, [activeSection, getSectionUiState]);

  // the sticky table headers park below the sticky tab bar, so they need its live height
  const { ref: tabBarRef, height: tabBarHeight } = useElementHeight();
  const stickyOffsetStyle = useMemo(
    () => ({ [stickyHeaderOffsetVar]: `${tabBarHeight}px` }),
    [tabBarHeight]
  );

  return {
    tabs,
    activeTab,
    activeTabType,
    handleTabClick,
    tabBarRef,
    stickyOffsetStyle,
    activeSection,
    activeSectionUiState,
    updateSectionComment,
    handleRegenerateSection,
    isSuggestedEditsLoading,
  };
};

export default useLifecareStudioBody;
